import { RefreshCw, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function FreshnessBanner({ onReload, onDismiss }) {
  return (
    <div
      className="flex items-center gap-3 px-4 py-2.5 bg-accent-amber/15 border-b border-accent-amber/30 text-sm"
      data-testid="freshness-banner"
    >
      <RefreshCw className="w-4 h-4 text-accent-amber flex-shrink-0" />
      <span className="flex-1 text-foreground/90">
        A newer version of this note is available from another device.
      </span>
      <Button
        size="sm"
        variant="outline"
        className="h-7 text-xs border-accent-amber/50 hover:bg-accent-amber/20"
        onClick={onReload}
        data-testid="freshness-reload-btn"
      >
        <RefreshCw className="w-3 h-3 mr-1" />
        Reload
      </Button>
      <button
        onClick={onDismiss}
        className="p-1 text-muted-foreground hover:text-foreground transition-colors"
        title="Keep editing current draft"
        data-testid="freshness-dismiss-btn"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
